import { createContext } from "react";

export const CustomBiodataContext = createContext({
    id: 0,
    image: '',
    color: '',
})